import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  connect() {
    console.log("Modal controller connected");
    this.close()
  }

  close() {
    const modal = Modal.getInstance(document.getElementById("remote-modal"))
    if (modal) modal.hide()
  }
}